module.exports = __webpack_public_path__ + "static/media/contractStatus.22bc246c.txt";